import React from 'react'
import { Navigate } from 'react-router-dom'
import Public from '../../pages/_layouts/Public'
import { useAuthStore } from '../../store/auth'
import { useUserStore } from '../../store/user'

export interface AuthRouteProps {
  Component: React.FunctionComponent
}

const AuthRoute: React.FunctionComponent<AuthRouteProps> = ({ Component }) => {
  const { signed, token } = useAuthStore((state) => state)
  const { user } = useUserStore((state) => state)

  if (signed && token) {
    const destination = user?.role === 'admin' ? '/' : '/documents'
    return <Navigate to={destination} replace />
  }

  return (
    <Public>
      <Component />
    </Public>
  )
}

export default AuthRoute

